import { Row, Col, Card, Button, Carousel } from "antd";
import "./index.css";
import { Link } from "react-router-dom";

const App = () => {
  return (
    <Carousel autoplay autoplaySpeed={4000} dotPosition="bottom" arrows>
      <Link to="/unduh">
        <Card
          bordered={false}
          cover={
            <img
              alt="banjir sumatra"
              src={process.env.PUBLIC_URL + "/static/images/banner_banjir_sumatra.png"}
            />
          }
        />
      </Link>
      <Card
        bordered={false}
        cover={
          <img
            alt="kebijakan sdi"
            src={process.env.PUBLIC_URL + "/static/images/banner_sdi.png"}
          />
        }
      />
      <Card
        bordered={false}
        cover={
          <img
            alt="monas"
            src={process.env.PUBLIC_URL + "/static/images/monas.jpg"}
          />
        }
      />
      <Card
        bordered={false}
        cover={
          <img
            alt="stadion"
            src={
              process.env.PUBLIC_URL + "/static/images/stadion_pakansari.jpg"
            }
          />
        }
      />
    </Carousel>
  );
};
export default App;
